var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { defaultTheme } from '@vital-ui/react-theme';
import baseStyle from '../components/FieldBase';
export var TextArea = styled.textarea(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  height: auto;\n  ", ";\n"], ["\n  ", ";\n  height: auto;\n  ", ";\n"])), baseStyle, function (props) { return !props.resize && 'resize: none'; });
TextArea.defaultProps = {
    alarm: false,
    rows: 3,
    resize: false,
    warning: false,
    theme: defaultTheme,
};
var templateObject_1;
//# sourceMappingURL=TextArea.js.map